import React from 'react';
import { IconProps } from '../../../lib/types';

const Salary: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37.5"
      height="37.5"
      viewBox="0 0 37.5 37.5"
      className={className}
    >
      <path
        d="M20.273 10.825a14.564 14.564 0 012.124.483.853.853 0 00.4.051 1.687 1.687 0 011.106 2.014 1.581 1.581 0 01-1.948 1.1c-.11-.029-.227-.059-.337-.1-.513-.139-1.025-.286-1.545-.388a5.366 5.366 0 00-3 .293c-.806.352-1.472 1.2-.557 1.787a6.99 6.99 0 002.432.857 1.67 1.67 0 00.513.205 13.06 13.06 0 013.691 1.487 4.146 4.146 0 011.78 4.263 4.361 4.361 0 01-2.82 3.267 6.885 6.885 0 01-1.846.454v1.113a1.582 1.582 0 01-3.164 0V26.44c-1.062-.234-2.1-.579-3.135-.916a1.582 1.582 0 111-3c.183.059.366.125.549.183a15.625 15.625 0 002.527.7 5.076 5.076 0 002.893-.256c.879-.293 1.289-1.333.432-1.919a6.851 6.851 0 00-2.527-.989c-.234-.051-.337-.1-.5-.139a13.61 13.61 0 01-3.523-1.37 3.95 3.95 0 01-1.847-4.134 4.528 4.528 0 012.856-3.223 4.178 4.178 0 011.282-.417V9.785a1.583 1.583 0 113.164 0zM37.5 18.75A18.75 18.75 0 1118.75 0 18.749 18.749 0 0137.5 18.75zM18.75 3.516A15.234 15.234 0 1033.984 18.75 15.232 15.232 0 0018.75 3.516z"
        className="a"
      ></path>
    </svg>
  );
};

export default Salary;
